import { errorMessages } from 'helpers/data/toastMessages';
import { Theme, toast } from 'react-toastify';

interface ThrowToastType {
    message: string;
}

interface ToastActionType {
    type: string;
    payload?: unknown;
    meta?: {
        arg?: unknown;
        requestId?: string;
    };
}

interface ThrowErrorMessageType extends ThrowToastType {
    action?: ToastActionType;
    errorCode?: number;
}

const getToastTheme = (): Theme => {
    try {
        const lexisConfString = localStorage.getItem('lexis-config');
        if (lexisConfString) {
            const lexisConf = JSON.parse(lexisConfString);
            if (lexisConf.mode === 'dark' || lexisConf.mode === 'light') {
                return lexisConf.mode;
            }
        }
    } catch (e) {
        console.error('Error parsing theme from localStorage', e);
    }
    return 'light';
};

const throwErrorToast = ({ errorCode, action, message }: ThrowErrorMessageType) => {
    if (action) {
        console.warn(`Type: ${action.type}`);
        if (errorCode) {
            console.warn(
                `We got a rejected action in API! (ERROR CODE ${errorCode}) - ${
                    (action.meta?.arg as { endpointName?: string })?.endpointName
                }`
            );
            console.warn(`${errorMessages[errorCode]}`);
            console.warn(action.payload);
        }
    }
    toast.error(message, {
        position: 'bottom-right',
        toastId: `${message}-${action?.type}-${errorCode}-${action?.meta?.requestId}`,
        autoClose: 3000,
        closeOnClick: true,
        theme: getToastTheme(),
    });
};

const throwInfoToast = ({ message }: ThrowToastType) => {
    toast.info(message, {
        position: 'bottom-right',
        autoClose: 1000,
        closeOnClick: true,
        theme: getToastTheme(),
    });
};

const throwSuccessToast = ({ message }: ThrowToastType) => {
    toast.success(message, {
        position: 'bottom-right',
        autoClose: 1000,
        closeOnClick: true,
        theme: getToastTheme(),
    });
};

export { throwErrorToast, throwInfoToast, throwSuccessToast };
